module.exports = __webpack_public_path__ + "img/C07TechLogThrowerChampion_ua.c4348b46.webp";